
import React from "react";
import { Helmet } from 'react-helmet-async';

import { Link } from "react-router-dom";

const Html5Games = () => {
  return (
    <div className="max-w-4xl mx-auto px-4 py-10 text-[#00F0FF]">
      <Helmet>
        <title>HTML5 Games Online | Play in Your Browser | BrowserArena</title>
        <meta name="description" content="Play HTML5 games directly in your browser on BrowserArena. Instant loading, no Flash required!" />
        <link rel="canonical" href="https://browserarena.com/html5-games" />
      </Helmet>

      <h1 className="text-3xl font-bold mb-4">Play HTML5 Games Online</h1>
      <p className="mb-4">
        HTML5 games are the future of browser-based gaming. They require no plugins and work seamlessly across all devices.
      </p>
      <p className="mb-4">
        At <strong>BrowserArena</strong>, we showcase the best <strong>HTML5 browser games</strong> from across the web. Enjoy fast loading times, responsive controls, and beautiful graphics.
      </p>
      <p className="mb-4">
        Explore our <Link to="/" className="text-[#FF007F] underline"> games</Link>, or check out <Link to="/best-browser-games" className="text-[#FF007F] underline">top-rated titles</Link>.
      </p>
      <p>
        Ready to play? Start now with our <Link to="/" className="text-[#FF007F] underline">free games</Link> collection!
      </p>
    </div>
  );
};

export default Html5Games;